// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3chUK","balanceDisclaimer":"posDashboard_balanceDisclaimer__263an"};